import { render, staticRenderFns } from "./sendNewYearCard.vue?vue&type=template&id=35c220e5"
import script from "./sendNewYearCard.vue?vue&type=script&lang=js"
export * from "./sendNewYearCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c220e5')) {
      api.createRecord('35c220e5', component.options)
    } else {
      api.reload('35c220e5', component.options)
    }
    module.hot.accept("./sendNewYearCard.vue?vue&type=template&id=35c220e5", function () {
      api.rerender('35c220e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/sendNewYearCard.vue"
export default component.exports